
angular.module('controllers')
    .controller('ServiceCtrl', ($scope, $state) => {

        const serviceId = $state.params.resourceId.toLowerCase();

        const checkService = () => {

            const familyLocator = CWCONFIG.features.familyLocator ? 'family-locator' : '';
            const validServices = [familyLocator];

            return validServices.indexOf(serviceId) >= 0;

        };

        if (!checkService()) {

            $state.go('root.dashboard.home');
            return;

        }

        if (serviceId) {

            $scope.dynamicDirectiveTag = `<${serviceId}-service></${serviceId}-service>`;

        }

    });



// WEBPACK FOOTER //
// ./scripts/controllers/dashboard/body/content/service-details/service-details.js